var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsfeedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4h13a2 2 0 0 1 2 2v12a2 2 0 0 0 2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 8,
    x2: 15,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 15,
    y2: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 16,
    x2: 11,
    y2: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsfeedIcon);
export default __webpack_public_path__ + "static/media/newsfeed-icon.08eb62863e8e20a1b0a2e00f2a92182c.svg";
export { ForwardRef as ReactComponent };